import React, { Fragment, useState } from 'react';
import getLevelFillPercent from 'components/AchievementLevel/getLevelFillPercent';

const getSegmentClass = (previousLevel, currentLevel) => {
  if (previousLevel < currentLevel) {
    return ' level-track__segment--done';
  }

  if (previousLevel === currentLevel) {
    return ' level-track__segment--current';
  }

  return '';
};

const getNodeClass = (levelNumber, currentLevel) => {
  if (levelNumber === currentLevel) {
    return ' level-track__node--current';
  }

  if (levelNumber < currentLevel) {
    return ' level-track__node--done';
  }

  return '';
};

const LevelNode = ({ level, currentLevel, openLevel, onSelect }) => (
  <button
    type="button"
    aria-label={level.name}
    className={`level-track__node${getNodeClass(level.level, currentLevel)}${
      openLevel === level.level ? ' level-track__node--open' : ''
    }`}
    onClick={() => onSelect(level.level)}>
    <span className="level-track__tooltip">{level.name}</span>
  </button>
);

const LevelStep = ({ level, previousLevel, levelSelection }) => (
  <Fragment>
    {previousLevel !== undefined && (
      <span
        className={`level-track__segment${getSegmentClass(
          previousLevel,
          levelSelection.currentLevel,
        )}`}
      />
    )}
    <LevelNode level={level} {...levelSelection} />
  </Fragment>
);

const LevelTrack = ({ levels, currentLevel, nextLevel }) => {
  const [openLevel, setOpenLevel] = useState(null);
  const levelSelection = { currentLevel, openLevel, onSelect: setOpenLevel };
  const progressStyle = {
    '--level-fill': `${getLevelFillPercent(nextLevel)}%`,
  };
  return (
    <div className="level-track" style={progressStyle}>
      {levels.map((level, index) => (
        <LevelStep
          key={level.level}
          level={level}
          previousLevel={levels[index - 1]?.level}
          levelSelection={levelSelection}
        />
      ))}
    </div>
  );
};

export default LevelTrack;
